(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tamzey-house"] && !Shopify.designMode) return;
  try {
    

(function(){
  document.querySelectorAll('[data-th-edit]').forEach(root=>{
    const tabs=Array.from(root.querySelectorAll('[data-th-edit-tab]'));
    const panels=Array.from(root.querySelectorAll('[data-th-edit-panel]'));
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    function activate(index,focus){
      tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index});
      if(focus)tabs[index].focus();
      tabs[index].scrollIntoView({block:'nearest',inline:'nearest',behavior:reduced.matches?'instant':'smooth'});
      panels[index].querySelector('[data-th-edit-track]').dispatchEvent(new Event('scroll'));
    }
    tabs.forEach((tab,i)=>{
      tab.addEventListener('click',()=>activate(i,false));
      tab.addEventListener('keydown',event=>{
        let next=i;
        if(event.key==='ArrowRight')next=(i+1)%tabs.length;
        else if(event.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=tabs.length-1;
        else return;
        event.preventDefault();activate(next,true);
      });
    });
    panels.forEach(panel=>{
      const track=panel.querySelector('[data-th-edit-track]');
      const prev=panel.querySelector('[data-th-edit-prev]');
      const next=panel.querySelector('[data-th-edit-next]');
      const status=panel.querySelector('[data-th-edit-status]');
      const retry=panel.querySelector('[data-th-edit-retry]');
      let pending=null, failed=false;
      function update(){
        prev.disabled=track.scrollLeft<=2;
        next.disabled=!track.dataset.nextPage&&track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
        if(!panel.hidden&&!pending&&!failed&&track.dataset.nextPage&&track.scrollWidth-track.clientWidth-track.scrollLeft<track.clientWidth*2)loadMore();
      }
      async function fetchPages(){
        status.textContent=status.dataset.loadingLabel;track.setAttribute('aria-busy','true');retry.hidden=true;
        try{
          let added=0;
          const seenPages=new Set();
          while(track.dataset.nextPage&&!added){
            const page=track.dataset.nextPage;
            if(seenPages.has(page))throw new Error('Repeated product page');
            seenPages.add(page);
            const url=new URL(page,window.location.href);
            url.searchParams.set('section_id',root.dataset.sectionId);
            const preview=new URLSearchParams(window.location.search).get('preview_theme_id');
            if(preview)url.searchParams.set('preview_theme_id',preview);
            const response=await fetch(url.toString(),{credentials:'same-origin'});
            if(!response.ok)throw new Error('Product page unavailable');
            const html=new DOMParser().parseFromString(await response.text(),'text/html');
            const source=html.getElementById(panel.id)?.querySelector('[data-th-edit-track]');
            if(!source)throw new Error('Product row unavailable');
            const ids=new Set(Array.from(track.querySelectorAll('[data-product-id]'),card=>card.dataset.productId));
            source.querySelectorAll('[data-product-id]').forEach(card=>{
              if(!ids.has(card.dataset.productId)){ids.add(card.dataset.productId);track.appendChild(card);added++}
            });
            track.dataset.nextPage=source.dataset.nextPage||'';
          }
          failed=false;
        }catch(_){failed=true;retry.hidden=false}
        finally{status.textContent='';track.setAttribute('aria-busy','false')}
      }
      function loadMore(){
        if(pending)return pending;
        if(!track.dataset.nextPage)return Promise.resolve();
        pending=fetchPages().finally(()=>{pending=null;update()});
        return pending;
      }
      async function move(direction){
        if(direction>0&&track.scrollLeft+track.clientWidth>=track.scrollWidth-2&&track.dataset.nextPage)await loadMore();
        const cards=track.querySelectorAll('.th-edit__product');
        if(!cards.length)return;
        const step=cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
        track.scrollBy({left:step*direction,behavior:reduced.matches?'instant':'smooth'});
      }
      retry.addEventListener('click',()=>{failed=false;loadMore()});
      prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);
      new ResizeObserver(update).observe(track);update();
    });
  });
})();


(function(){
  const bar=document.querySelector('[data-th-announcement]');
  if(!bar)return;
  const slides=Array.from(bar.querySelectorAll('[data-th-announcement-slide]'));
  const pause=bar.querySelector('[data-th-announcement-pause]');
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  let index=0, timer=null, stopped=motion.matches, hovered=false;
  function sync(){
    clearInterval(timer);
    pause.setAttribute('aria-pressed',String(stopped));
    pause.setAttribute('aria-label',stopped?pause.dataset.playLabel:pause.dataset.pauseLabel);
    pause.firstElementChild.textContent=stopped?'▶':'Ⅱ';
    if(!stopped&&!hovered&&!bar.contains(document.activeElement)&&!document.hidden)timer=setInterval(()=>show(index+1),6000);
  }
  function show(next){
    index=(next+slides.length)%slides.length;
    slides.forEach((slide,i)=>{slide.hidden=i!==index});
  }
  bar.querySelector('[data-th-announcement-prev]').addEventListener('click',()=>{show(index-1);sync()});
  bar.querySelector('[data-th-announcement-next]').addEventListener('click',()=>{show(index+1);sync()});
  pause.addEventListener('click',()=>{stopped=!stopped;sync()});
  bar.addEventListener('mouseenter',()=>{hovered=true;sync()});
  bar.addEventListener('mouseleave',()=>{hovered=false;sync()});
  bar.addEventListener('focusin',sync);
  bar.addEventListener('focusout',()=>setTimeout(sync,0));
  document.addEventListener('visibilitychange',sync);
  motion.addEventListener('change',()=>{stopped=motion.matches;sync()});
  sync();
})();

(function(){

  const headerMenu = document.querySelector('.th-header-menu');
  if (headerMenu) {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && headerMenu.open) {
        headerMenu.open = false;
        headerMenu.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (headerMenu.open && !headerMenu.contains(event.target)) headerMenu.open = false;
    });
  }
  const nav = document.querySelector('[data-house-nav]');
  const reveals = document.querySelectorAll('.th-reveal');
  const rooms = document.querySelectorAll('[data-room]');
  const roomLinks = document.querySelectorAll('[data-room-link]');
  const directory = document.querySelector('.th-directory');
  const themeZones = Array.from(document.querySelectorAll('[data-ui-theme]')).filter((el) => el !== nav && el !== directory);

  function themeAtY(y){
    for (const zone of themeZones) {
      const rect = zone.getBoundingClientRect();
      if (rect.top <= y && rect.bottom > y) return zone.getAttribute('data-ui-theme') || 'light';
    }
    return 'light';
  }

  let uiFrame = null;
  function updateAdaptiveUI(){
    uiFrame = null;
    const navTheme = themeAtY(Math.min(148, window.innerHeight * .25));
    const directoryTheme = themeAtY(window.innerHeight * .5);

    if (nav) {
      nav.setAttribute('data-ui-theme', navTheme);
      nav.classList.toggle('is-scrolled', window.scrollY > 40);
    }
    if (directory) directory.setAttribute('data-ui-theme', directoryTheme);
  }

  function requestAdaptiveUI(){
    if (uiFrame) return;
    uiFrame = requestAnimationFrame(updateAdaptiveUI);
  }

  updateAdaptiveUI();
  window.addEventListener('scroll', requestAdaptiveUI, {passive:true});
  window.addEventListener('resize', requestAdaptiveUI, {passive:true});


  const trustViewport = document.querySelector('[data-trust-slider]');
  const trustCards = trustViewport ? Array.from(trustViewport.querySelectorAll('.th-trust-card')) : [];
  const trustDots = Array.from(document.querySelectorAll('[data-trust-dot]'));
  let trustIndex = 0;
  let trustTimer = null;

  function showTrust(index){
    if (!trustViewport || !trustCards.length) return;
    trustIndex = (index + trustCards.length) % trustCards.length;
    const card = trustCards[trustIndex];
    trustViewport.scrollTo({left:card.offsetLeft - (trustViewport.clientWidth - card.clientWidth)/2,behavior:'smooth'});
    trustDots.forEach((dot,i)=>dot.classList.toggle('is-active',i===trustIndex));
  }

  function startTrust(){
    if (!trustViewport || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    clearInterval(trustTimer);
    trustTimer = setInterval(()=>showTrust(trustIndex+1),4800);
  }

  trustDots.forEach((dot)=>{
    dot.addEventListener('click',()=>{
      showTrust(Number(dot.getAttribute('data-trust-dot')) || 0);
      startTrust();
    });
  });
  if (trustViewport) {
    trustViewport.addEventListener('pointerdown',()=>clearInterval(trustTimer),{passive:true});
    trustViewport.addEventListener('pointerup',startTrust,{passive:true});
    startTrust();
  }


  const tzViewport = document.querySelector('[data-tz-standard-slider]');
  const tzSlides = tzViewport ? Array.from(tzViewport.querySelectorAll('[data-tz-slide]')) : [];
  const tzDots = Array.from(document.querySelectorAll('[data-tz-dot]'));
  const tzCurrent = document.querySelector('[data-tz-current]');
  const tzNext = document.querySelector('[data-tz-next]');
  let tzIndex = 0;
  let tzTimer = null;
  let tzFrame = null;

  function tzSetActive(index){
    if (!tzSlides.length) return;
    tzIndex = (index + tzSlides.length) % tzSlides.length;
    tzSlides.forEach((slide,i)=>slide.classList.toggle('is-active',i===tzIndex));
    tzDots.forEach((dot,i)=>dot.classList.toggle('is-active',i===tzIndex));
    if (tzCurrent) tzCurrent.textContent = String(tzIndex+1).padStart(2,'0');
  }
  function tzShow(index){
    if (!tzViewport || !tzSlides.length) return;
    tzSetActive(index);
    const slide = tzSlides[tzIndex];
    tzViewport.scrollTo({
      left:slide.offsetLeft - (tzViewport.clientWidth - slide.clientWidth)/2,
      behavior:'smooth'
    });
  }
  function tzStart(){
    if (!tzViewport || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    clearInterval(tzTimer);
    tzTimer = setInterval(()=>tzShow(tzIndex+1),5600);
  }
  tzDots.forEach((dot)=>dot.addEventListener('click',()=>{
    tzShow(Number(dot.getAttribute('data-tz-dot'))||0);
    tzStart();
  }));
  if (tzNext) tzNext.addEventListener('click',()=>{tzShow(tzIndex+1);tzStart();});
  if (tzViewport){
    tzViewport.addEventListener('mouseenter',()=>clearInterval(tzTimer));
    tzViewport.addEventListener('mouseleave',tzStart);
    tzViewport.addEventListener('pointerdown',()=>clearInterval(tzTimer),{passive:true});
    tzViewport.addEventListener('pointerup',tzStart,{passive:true});
    tzViewport.addEventListener('scroll',()=>{
      if(tzFrame) cancelAnimationFrame(tzFrame);
      tzFrame=requestAnimationFrame(()=>{
        const centre=tzViewport.scrollLeft+tzViewport.clientWidth/2;
        let nearest=0,dist=Infinity;
        tzSlides.forEach((slide,i)=>{
          const d=Math.abs((slide.offsetLeft+slide.clientWidth/2)-centre);
          if(d<dist){dist=d;nearest=i;}
        });
        tzSetActive(nearest);
      });
    },{passive:true});
    tzSetActive(0);
    tzStart();
  }

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {threshold:0.12});
    reveals.forEach((item) => revealObserver.observe(item));

    const roomObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const room = entry.target.getAttribute('data-room');
        roomLinks.forEach((link) => {
          link.classList.toggle('is-active', link.getAttribute('data-room-link') === room);
        });
      });
    }, {rootMargin:'-40% 0px -45% 0px', threshold:0});
    rooms.forEach((room) => roomObserver.observe(room));
  } else {
    reveals.forEach((item) => item.classList.add('is-visible'));
  }
})();

(function(){
  const popup = document.querySelector('[data-th-welcome]');
  if (!popup || typeof popup.showModal !== 'function') return;
  const dismissedKey = 'tamzey-welcome-dismissed-v1';
  const joinedKey = 'tamzey-welcome-joined-v1';
  const preview = new URLSearchParams(window.location.search).get('tamzey_popup') === '1';
  const success = popup.querySelector('[data-th-welcome-success]');
  const error = popup.querySelector('[data-th-welcome-error]');
  let previousOverflow = '';
  let previousFocus = null;
  function getStored(key) { try { return localStorage.getItem(key); } catch (_) { return null; } }
  function setStored(key, value) { try { localStorage.setItem(key, value); } catch (_) {} }
  function openPopup() {
    if (popup.open) return;
    previousOverflow = document.body.style.overflow;
    previousFocus = document.activeElement;
    popup.showModal();
    document.body.style.overflow = 'hidden';
    if (success) success.focus();
  }
  document.querySelectorAll('[data-th-offer-open]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); openPopup(); }));
  function closePopup() { if (popup.open) popup.close(); }
  popup.querySelectorAll('[data-th-welcome-close]').forEach(button => button.addEventListener('click', closePopup));
  popup.addEventListener('click', event => { if (event.target === popup) closePopup(); });
  popup.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    setStored(dismissedKey, String(Date.now()));
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  });
  if (success) setStored(joinedKey, '1');
  if (success || error || preview || (window.Shopify && Shopify.designMode)) {
    openPopup();
    return;
  }
  const dismissedAt = Number(getStored(dismissedKey)) || 0;
  if (popup.dataset.customerSubscribed === 'true' || getStored(joinedKey) || Date.now() - dismissedAt < 7 * 24 * 60 * 60 * 1000) return;
  let attempts = 0;
  function tryOpen() {
    attempts += 1;
    if (document.hidden || document.querySelector('dialog[open], .th-header-menu[open], cart-drawer.active, .menu-drawer-container[open]')) {
      if (attempts < 12) setTimeout(tryOpen, 5000);
      return;
    }
    openPopup();
  }
  setTimeout(tryOpen, 8000);
})();


(function(){
  const menu=document.querySelector('.th-desktop-nav');
  const hamburger=document.querySelector('.th-header-menu');
  if(!menu)return;
  const items=Array.from(menu.querySelectorAll('.th-desktop-nav__item'));
  const desktop=window.matchMedia('(min-width:990px)');
  const hover=window.matchMedia('(hover:hover) and (pointer:fine)');
  items.forEach(item=>{
    item.addEventListener('mouseenter',()=>{if(desktop.matches&&hover.matches){if(hamburger)hamburger.open=false;items.forEach(other=>{other.open=other===item})}});
    item.addEventListener('mouseleave',()=>{if(hover.matches&&!item.contains(document.activeElement))item.open=false});
    item.addEventListener('toggle',()=>{if(item.open&&hamburger)hamburger.open=false});
    item.addEventListener('focusout',()=>setTimeout(()=>{if(!item.contains(document.activeElement))item.open=false},0));
  });
  if(hamburger)hamburger.addEventListener('toggle',()=>{if(hamburger.open)items.forEach(item=>item.open=false)});
  document.addEventListener('click',event=>{if(!menu.contains(event.target))items.forEach(item=>item.open=false)});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){const active=items.find(item=>item.open);if(active){active.open=false;active.querySelector('summary').focus()}}});
  desktop.addEventListener('change',()=>{if(!desktop.matches)items.forEach(item=>item.open=false)});
})();


  } catch(e) { console.error(e); }
})();
})();
